import { useDispatchLegends } from 'components/common/legendContext'
import { getEventRSC } from 'helpers/rsc'
import React, { useLayoutEffect } from 'react'

const RecordIndicator = ({ records, eventRsc, disableLegend = false }) => {
    const filterRecords = records?.filter(rec => eventRsc ? rec?.ri_order === 1 && eventRsc === getEventRSC(rec.record.event) : rec?.ri_order === 1)
    const dispatch = useDispatchLegends();

    useLayoutEffect(() => {
        if (!disableLegend && dispatch && filterRecords?.length > 0) {
            const recordItems = filterRecords?.map(rec => { return { id: rec?.ri_recordtype, name: rec?.recordType?.description } })
            recordItems?.forEach((payload) => {
                dispatch({
                    type: 'addlegend',
                    payload: payload
                })
            })
        }
    });

    return (
        Array.isArray(filterRecords) && filterRecords?.map(rec =>
            <abbr
                title={rec?.recordType?.description}
                key={`recordIndicator-${rec?.ri_recordtype}-${rec?.ri_order}`}>
                {(rec?.ri_equalled === 'Y' ? '=' : '') + rec?.ri_recordtype}
            </abbr>)
    )
}

export default RecordIndicator